import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { I9BeneficiaryLandingComponent } from './components/i9-beneficiary-landing/i9-beneficiary-landing.component';
import { CreateI9FormComponent } from './components/create-i9-form/create-i9-form.component';
import { DirtyFormGuard } from 'src/app/dirty-form.guard';

const routes: Routes = [  
  {
      path: '',
      component: I9BeneficiaryLandingComponent
  },
  { 
    path: 'new', 
    component: CreateI9FormComponent,
    canDeactivate: [DirtyFormGuard]
  },
  {
    path: 'edit-form',
    component:CreateI9FormComponent,
    canDeactivate: [DirtyFormGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class I9BeneficiaryRoutingModule { }
